import React from 'react'
import { BroadsheetHeadline } from '@/components/dashboard/broadsheet/BroadsheetHeadline'
import { BroadsheetKVList } from '@/components/dashboard/broadsheet/BroadsheetKVList'
import { TIER_PRICING } from '@/lib/constants'

/**
 * SignupEditorial
 *
 * Value-prop copy for the /signup two-pane editorial pane.
 * Message: "Mint.com for AI spend — start free, Pro is $29/mo."
 */
export function SignupEditorial(): React.ReactElement {
  return (
    <>
      <div>
        <p className="text-[11px] font-mono uppercase tracking-[0.15em] text-graphite">
          Start free — no card required
        </p>
        <BroadsheetHeadline className="mt-2">
          Mint.com for AI spend — start free today.
        </BroadsheetHeadline>
      </div>

      <BroadsheetKVList
        items={[
          { label: 'Providers supported', value: 'Anthropic, OpenAI, Gemini +' },
          { label: 'Setup time', value: '< 5 minutes' },
          { label: 'Pro plan', value: `$${TIER_PRICING.personal_pro.monthly}/mo` },
          { label: 'Team dashboards', value: 'Coming soon' },
        ]}
      />

      <p className="text-[11px] text-graphite leading-relaxed">
        Track your team&rsquo;s AI spend across every provider, set budget alerts,
        and see exactly where your money is going — all in one place.
      </p>
    </>
  )
}
